<template>
<v-card flat>
  <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="add">Novo Sabor</v-btn>
  </v-toolbar>
  <v-data-table
    :loading="loading"
    :headers="computedHeaders"
    :items="flavors"
    disable-initial-sort
    :rows-per-page-items="[10,25,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
    >
    <template v-slot:items="props">
        <td class="hidden-sm-and-down">{{ props.item.code }}</td>
        <td>{{ props.item.recheio }}</td>
        <td class="hidden-md-and-down">{{ props.item.ingredientes }}</td>
        <td v-for="size in sizes" :key="props.item.code+'-'+size.code" class="hidden-md-and-down">
            {{price(props.item.price_list[size._id] || 0)}}
        </td>
        <td>
        <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
        >
            edit
        </v-icon>
        <v-icon
            small
            class="mr-2"
            @click="toggleStatus(props.item._id, props.item.enabled)"
        >
            {{(props.item.enabled)?'visibility': 'visibility_off'}}
        </v-icon>
        <v-icon
            small
            @click="removeSize(props.item._id)"
        >
            delete
        </v-icon>
        </td>
    </template>
  </v-data-table>
  <v-dialog v-model="formSabores" v-if="formSabores" max-width="500px">
      <v-card>
          <v-card-title>
          <span class="headline">{{ (editedIndex == -1)?"Novo Sabor":"Editar Sabor"}}</span>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                    <v-text-field 
                    v-model="editedItem.recheio" 
                    label="Nome" placeholder="Portuguesa"
                    autofocus v-if="formSabores"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-textarea v-model="editedItem.ingredientes" label="Ingredientes"
                    auto-grow rows="2" placeholder="Mussarela, calabresa, ovo, cebola, azeitona preta e orégano."
                    ></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="editedItem.code" type="number" label="Código">
                    </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                    <span class="headline">Preços</span>
                </v-flex>
                <v-flex xs12 sm6 md4 v-for="size in sizes" :key="'edit-'+size.code">
                    <v-text-field
                        v-model.lazy="editedItem.price_list[size._id]" 
                        :label="size.tamanho"
                        v-money="config"
                        ref="price"
                        prefix="R$"
                    ></v-text-field>
                </v-flex>
              </v-layout>
          </v-container>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent darken-1" flat @click="close" :disabled="loading">Cancelar</v-btn>
          <v-btn color="accent darken-1" flat @click="save" :loading="loading">Salvar</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    props:['flavorsData'],
    data(){
        return {
            config: {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2},
            button:null,
            headers: [
                { text: 'Código', value: 'code', hide:"smAndDown" },
                {
                text: 'Nome',
                align: 'left',
                sortable: true,
                value: 'recheio'
                },
                { text: 'Ingredientes', value: 'ingredientes' ,hide:"mdAndDown"},
                { text: 'Ações', value: 'actions', sortable: false }
            ],
            headersDefault:[
                { text: 'Código', value: 'code', width:"80px", hide:"smAndDown" },
                {
                text: 'Nome',
                align: 'left',
                sortable: true,
                value: 'recheio'
                },
                { text: 'Ingredientes', value: 'ingredientes', hide:"mdAndDown"},
            ],
            flavors: [],
            formSabores:false,
            tab:0,
            editedIndex: -1,
            editedItem: {
                recheio: '',
                code: 0,
                ingredientes: '',
                enabled:true,
                price_list:{}
            },
            defaultItem: {
                recheio: '',
                code: 0,
                ingredientes: '',
                enabled:true,
                price_list:{}
            },
            loading: false
        }
    },
    async mounted(){
        this.flavors = this.flavorsData
        this.setPrices()
        this.editedItem.code = await this.$store.dispatch('generateCode')
    },
    watch:{
        formSabores(val) {
            val || this.close()
        },
        sizes(v){
            this.setPrices()
        }
    },
    computed: {
        ...mapGetters([
            'typeSelected',
            'sizes'
        ]),
        computedHeaders(){
            return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide])
        },
        productDialog:{
            get(){
                return this.$store.state.productDialog
            },
            set(v){
                this.$store.state.productDialog = v
            }
        },
        search:{
            get(){
                return this.$store.state.search
            },
            set(value){
                if(!value)value=''
                return this.$store.state.search = value
            }
        },
    },
    methods:{
        setPrices(){
            const aux = JSON.parse(JSON.stringify(this.headersDefault))
            this.sizes.forEach(size=>{
                aux.push({
                    text: size.tamanho.substr(0,8)+"...", value: 'price_list', sortable: false, width:"80px",
                    hide:"mdAndDown"
                })
            })
            aux.push({ text: 'Ações', value: 'actions', sortable: false, width:"135px" })
            this.headers = aux
        },
        async add(){
            this.editedItem.code = await this.$store.dispatch('generateCode')
            this.formSabores = true
        },
        async fetchData(){
            this.flavors = await this.$store.dispatch("fetchPizzaFlavor")
        },
        searchAction(){
            if(this.search && this.search.trim().length >= 3 || this.search.trim().length == 0 ){
                this.$store.dispatch('fetchProducts')
                this.$store.dispatch('fetchMenu')
            }
        },
        price(v){
            return 'R$' + Number(v).toFixed(2).toString().replace('.',',')
        },
        editItem (item) {
            this.editedIndex = this.flavors.indexOf(item)
            const aux = JSON.parse(JSON.stringify(item))
            Object.keys(aux.price_list).forEach(v=>{
                aux.price_list[v] = aux.price_list[v].toFixed(2)
            })
            this.editedItem = aux
            this.formSabores = true
        },
        async toggleStatus(id, status){
            if(confirm(`Tem certeza que deseja ${(status)?'desativar':'ativar'} esse recheio?`)){
                this.loading = true
                await this.$store.dispatch('togglePizzaStatus',{id, status})
                this.fetchData()
                this.loading = false
            }
        },
        async removeSize(id){
            if(confirm('Tem certeza que deseja excluir esse recheio?')){
                this.loading = true
                await this.$store.dispatch('removePizzaFlavor',id)
                this.fetchData()
                this.loading = false
            }
        },
        close () {
            this.formSabores = false
            setTimeout(async () => {
                this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
                this.editedItem.code = await this.$store.dispatch('generateCode')
                this.editedIndex = -1
            }, 300)
        },
        async save(){
            try {
                this.loading = true
                const data = JSON.parse(JSON.stringify(this.editedItem))
                data.codigo = data.code
                
                const action = (this.editedIndex == -1)?'createPizzaFlavor':'updatePizzaFlavor'
                await this.$store.dispatch(action,data)
                this.fetchData()
                this.close()
                this.loading = false
            } catch (error) {
                if(error === 'O código digitado já está sendo utilizado em outro produto.'){
                    this.editedItem.code = await this.$store.dispatch('generateCode')
                    this.save()
                }else{
                    this.$toasted.show(error)
                    this.loading = false
                }
            }
        }
    }
}
</script>

<style>

</style>